import React from "react";
import { Form, Label, Select, LabelInput, DatePickerInput } from "../../common/components/form";
import Button from "../../../ui/button/Button";
import moment from "moment";
import { rem } from "polished";
import styled from "styled-components";
import { Localize } from "../../../locale/localization";
import { media } from "../../../utils/uiSizes";
import { StyledError, StyledInputWrapper } from "../../common/components/form/ui/";

const DateWrapper = styled.div`
  width: 100%;
  min-height: ${rem("480px")};
  ${media.tablet`
    min-height: ${rem("420px")};  
  `};
`;

const CampaignForm = props => {
  const {
    enabled,
    onSubmit,
    onCancel,
    onDelete,
    onBlur,
    onInputChange,
    errors,
    touchedFields,
    isValid,
    channel,
    channels,
    startDate,
    endDate,
    bonusPercentage,
    showDeleteButton
  } = props;

  const options = channels
    ? channels.map(op => (
        <option key={op._id} value={op._id}>
          {op.name}
        </option>
      ))
    : null;

  const firstPossibleDate = moment().startOf("year");
  let lastPossibleDate = moment().endOf("year");
  lastPossibleDate.year(lastPossibleDate.year() + 1);

  return (
    <Form
      onSubmit={onSubmit}
      autoCorrect="off"
      autoComplete="off"
      noValidate
      spellCheck="false"
      onBlur={onBlur}
    >
      <Label label={Localize("campaign.channel")} half>
        <Select
          value={channel}
          name="channel"
          error={errors["channel"] && touchedFields.indexOf("channel") > -1}
          errorMessage={errors["channel"]}
          onChange={onInputChange}
        >
          {options}
        </Select>
      </Label>

      <LabelInput
        half
        type="number"
        label="Tiiminvetäjän bonuskerroin %"
        name="bonusPercentage"
        value={bonusPercentage}
        error={errors["bonusPercentage"] && touchedFields.indexOf("bonusPercentage") > -1}
        errorMessage={errors["bonusPercentage"]}
        onChange={onInputChange}
      />

      <DateWrapper>
        <Label half label={Localize("campaign.startDate")}>
          <DatePickerInput
            type="text"
            name="startDate"
            half
            value={startDate}
            error={errors["startDate"] && touchedFields.indexOf("startDate") > -1}
            errorMessage={errors["startDate"]}
            onChange={onInputChange}
            firstPossibleDate={firstPossibleDate}
            lastPossibleDate={lastPossibleDate}
          />
        </Label>

        <Label half label={Localize("campaign.endDate")}>
          <DatePickerInput
            type="text"
            name="endDate"
            half
            value={endDate}
            error={errors["endDate"] && touchedFields.indexOf("endDate") > -1}
            errorMessage={errors["endDate"]}
            onChange={onInputChange}
            firstPossibleDate={startDate}
            lastPossibleDate={lastPossibleDate}
          />
        </Label>
      </DateWrapper>

      {errors["campaignExistsError"] && (
        <StyledInputWrapper className="error">
          <StyledError
            dangerouslySetInnerHTML={{ __html: Localize("form.campaign.exists.error") }}
          />
        </StyledInputWrapper>
      )}

      <footer>
        <Button theme="light" onClick={onCancel}>
          {Localize("action.cancel")}
        </Button>
        {showDeleteButton && (
          <Button theme="light" onClick={onDelete}>
            {Localize("action.delete")}
          </Button>
        )}
        <Button disabled={!isValid || !enabled} type="submit">
          {Localize("action.submit")}
        </Button>
      </footer>
    </Form>
  );
};

export default CampaignForm;



// WEBPACK FOOTER //
// ./src/modules/campaign/components/CampaignForm.js